// Matrice des droits d'écriture par module (le backend reste la source de vérité).
// Administrateur : accès total. Direction & Consultation : lecture seule.
const WRITE_ROLES = {
  depenses: ["comptabilite"],
  caisse: ["comptabilite"],
  banque: ["comptabilite"],
  factures_fournisseurs: ["comptabilite"],
  fournisseurs: ["comptabilite", "commercial"],
  achats: ["comptabilite", "magasinier"],
  clients: ["commercial", "comptabilite"],
  ventes: ["commercial", "comptabilite"],
  livraisons: ["commercial", "magasinier"],
  stock: ["magasinier"],
  produits: ["magasinier"],
  inventaire: ["magasinier"],
  production: ["production"],
  recettes: ["production", "magasinier"],
  parametres: [],
};

export const ROLE_LABELS = {
  administrateur: "Administrateur",
  direction: "Direction",
  comptabilite: "Comptabilité",
  commercial: "Commercial",
  magasinier: "Magasinier",
  production: "Production",
  consultation: "Consultation",
};

export function canWrite(role, module) {
  if (!role) return false;
  if (role === "administrateur") return true;
  return (WRITE_ROLES[module] || []).includes(role);
}

export function canViewAudit(role) {
  return role === "administrateur" || role === "direction";
}
